import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, Facebook, Instagram } from "lucide-react";
import { BRAND } from "../lib/api";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/5 bg-[#0B0C0E]">
      <div className="section-container py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="font-serif text-2xl text-[color:var(--lume-gold-light)]">LUME</span>
            <span className="text-[color:var(--lume-gold)]">·</span>
            <span className="font-serif text-2xl text-white">Enterprise</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">Private chauffeured transportation for executives, travelers, families, and life's finest occasions.</p>
        </div>
        <div>
          <div className="eyebrow mb-4">Explore</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/services" className="hover:text-[color:var(--lume-gold)]">Services</Link></li>
            <li><Link to="/fleet" className="hover:text-[color:var(--lume-gold)]">Fleet</Link></li>
            <li><Link to="/reviews" className="hover:text-[color:var(--lume-gold)]">Reviews</Link></li>
            <li><Link to="/faq" className="hover:text-[color:var(--lume-gold)]">FAQ</Link></li>
            <li><Link to="/booking" className="hover:text-[color:var(--lume-gold)]">Book a Ride</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Reach Us</div>
          <a href={`tel:${BRAND.phoneRaw}`} className="flex items-center gap-2 text-sm text-slate-300 hover:text-white mb-2" data-testid="footer-phone"><Phone size={14}/> {BRAND.phone}</a>
          <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 text-sm text-slate-300 hover:text-white" data-testid="footer-email"><Mail size={14}/> {BRAND.email}</a>
        </div>
        <div>
          <div className="eyebrow mb-4">Follow</div>
          <div className="flex gap-3">
            <a href="https://www.facebook.com/share/18DUU6DpKD/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-[color:var(--lume-gold)] transition-colors text-slate-300 hover:text-[color:var(--lume-gold)]" data-testid="social-facebook" aria-label="Lume Enterprise on Facebook"><Facebook size={16}/></a>
            <a href="https://www.tiktok.com/@lumeenterprise?_r=1&_t=ZT-99vqXmAilWH" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-[color:var(--lume-gold)] transition-colors text-slate-300 hover:text-[color:var(--lume-gold)]" data-testid="social-tiktok" aria-label="Lume Enterprise on TikTok">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-2.31-2.83V9.32a6.34 6.34 0 1 0 5.76 6.33V8.73a8.16 8.16 0 0 0 4.77 1.52V6.8a4.85 4.85 0 0 1-1-.11z"/></svg>
            </a>
            <a href="https://instagram.com/lumeenterprise" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:border-[color:var(--lume-gold)] transition-colors text-slate-300 hover:text-[color:var(--lume-gold)]" data-testid="social-instagram" aria-label="Lume Enterprise on Instagram"><Instagram size={16}/></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="section-container py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Lume Enterprise. All rights reserved.</div>
          <div><Link to="/admin" className="hover:text-slate-300" data-testid="footer-admin-link">Admin</Link> · <Link to="/corporate" className="hover:text-slate-300" data-testid="footer-corp-link">Corporate</Link></div>
        </div>
      </div>
    </footer>
  );
}
